import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "row align-items-end" }
const _hoisted_4 = { class: "col-sm-6" }
const _hoisted_5 = { style: {"margin":"-36px 0 -36px 0"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center mb-4" }, [
        _createElementVNode("span", { class: "d-inline-block border-success border bg-success bg-opacity-10 text-success rounded-pill fs-12 fw-medium px-2" }, "+ 35%"),
        _createElementVNode("span", { class: "fs-12" }, "Last 30 days")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-sm-6" }, [
          _createElementVNode("span", { class: "d-block mb-2" }, "Properties for Rent"),
          _createElementVNode("h3", { class: "mb-0 fs-20 mb-0" }, "2,510")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.isClient)
              ? (_openBlock(), _createBlock(_component_apexchart, {
                  key: 0,
                  type: "radialBar",
                  height: "170",
                  options: _ctx.propertiesForRent,
                  series: _ctx.rent
                }, null, 8, ["options", "series"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}